import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

import { ReviewTargetModel } from '@models/index'


@Injectable({
  providedIn: 'root',
})
export class ReviewTargetsService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  constructor(
    private http: HttpClient
  ) { }

  searchAllReviewTargets(payload: { page: number; size: number }): Observable<{ data: ReviewTargetModel[], total: number }> {
    return of({
      data: [
       ], total: 0
    })
  }

  createReviewTarget(reviewTarget: ReviewTargetModel): Observable<ReviewTargetModel> {
    return of(reviewTarget)
  }

  deleteReviewTarget(reviewTargetId: string): Observable<string> {
    return of(reviewTargetId)
  }

  searchAllReviewTargetsByQuery(payload: { page: number; size: number, query: string }): Observable<{ data: ReviewTargetModel[], total: number }> {
    return of({ data: [], total: 0 })
  }
}
